/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMapBrokerageCode.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/map-brokerage-code";

export class AutogenModelMapBrokerageCode<RowType extends ModelRow> extends Endpoint<RowType, RowMapBrokerageCodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMapBrokerageCode extends ModelRow<RowMapBrokerageCodeFields> {
	constructor(values?: Partial<RowMapBrokerageCodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMapBrokerageCodeFields {
	allocation_code: string;
	allow_for_rate_exceptions: string;
	code_source: string;
	code_type: string;
	company_id: string;
	description: string;
	from_code: string;
	from_code_desc: string;
	gla_code: string;
	gla_type_code: string;
	gla_uid: number;
	income_account: string;
	pay_code: string;
	power_expense_acct: string;
	rev_calc_priority: number;
	sales_expense_acct: string;
	send_accessorial_varieties: string;
	short_description: string;
	to_code: string;
	code_source: string;
	code_type: string;
	find_error: boolean;
	from_code: string;
	to_code: string;
}

